export default "__VITE_ASSET__tc6jZuSi__"